import { FetchServicesOnTenderDocument, FetchServicesOnTenderQuery } from "@/graphql/__generated__/graphql";
import { useQuery } from "@apollo/client/react";
import { FetchServicesOnTenderQueryVariables } from "@/graphql/__generated__/graphql";

export const useFetchServicesOnTenderQueryHook = (currentTenderID: number, withPricing: boolean = false, withTotalPricePerHour: boolean = false) => {
  const { data, loading, refetch } = useQuery<FetchServicesOnTenderQuery, FetchServicesOnTenderQueryVariables>(
    FetchServicesOnTenderDocument, {
      variables: {
        tenderId: Number(currentTenderID),
        withPricing,
        withTotalPricePerHour
      },
      fetchPolicy: "cache-and-network"
    });

  return {
    data, loading, refetch
  };
};
